import { Injectable } from 'angular-ts-decorators';

/**
 * Service that provides information about OS.
 */
@Injectable('osSniffer')
export class OsSniffer {
  info: {
    fullName?: string;
    majorVersion?: number;
    minorVersion?: number;
    name?: string;
    patchVersion?: number;
    version?: string;
    versionAltNames?: string[];
    versionName?: string;
  } = {};

  constructor($window: ng.IWindowService, sniffer) {
    'ngInject';

    this.info = sniffer($window.navigator.userAgent).os;
  }

  isUnsupportedWindows() {
    return this.info.fullName === 'Windows' && this.info.majorVersion <= 7;
  }
}
